import { AddOn } from '@softline/application';
import { DestroyRef, inject, AbstractType } from '@angular/core';

export function addOnHost<TAddOn extends AddOn<TParams>, TParams>(addOnType: AbstractType<TAddOn>, params: TParams): void {
  const destroyRef = inject(DestroyRef);
  const addOns = inject(addOnType, { optional: true }) as TAddOn[] | null;
  for (const addOn of addOns ?? [])
    addOn.onAttach(params);
  destroyRef.onDestroy(async () => {
    for (const addOn of addOns ?? [])
      await addOn.onDetach(params);
  })
}
